module.exports = __webpack_public_path__ + "static/media/nft-31.60b39f3c.jpg";